<template>
    <div class="faq">
        <div class="faq-title">
            <CommonComponentsSVGProductStudioFAQ />
            <div class="faq-title-text">{{ $t('global_studio_FAQs') }}</div>
        </div>
        <div class="faq-body">
            <div class="faq-body-text" v-for="(item, index) in FAQData" :key="index">
                <div class="faq-body-text-Q">{{ $t(item.question) }}</div>
                <div v-if="item.answertext" class="faq-body-text-A">
                    <span>{{ $t(item.answertext) }}</span>
                    <a @click="showModal()">{{ $t(item.answertext1) }}</a>
                    <span>{{ $t(item.answertext2) }}</span>
                </div>
                <div v-if="item.answer" class="faq-body-text-A" v-html="$t(item.answer)"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, onMounted } from 'vue';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    const ifMatched = ref(false);
    const FAQData = [
        {
            question: 'global_studio_question_0',
            answertext: 'global_studio_answertext_0',
            answertext1: 'global_studio_answertext_1',
            answertext2: 'global_studio_answertext_2',
        },
        {
            question: 'global_studio_question_1',
            answer: 'global_studio_answer_1',
        },
        {
            question: 'global_studio_question_2',
            answer: 'global_studio_answer_2',
        },
    ];

    const { $bus } = useNuxtApp();
    const showModal = () => {
        if (ifMatched.value) {
            // 移动 端，展开Header
            $bus.$emit('show:mobileNav');
        } else {
            // PC 端，打开弹窗
            $bus.$emit('show:applyModal');
        }
    };

    onMounted(() => {
        ifMatched.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .faq {
        margin-top: .convert(80px) [ @vw];
        margin-bottom: .convert(60px) [ @vw];
        display: flex;
        width: 100%;
        padding: .convert(50px) [ @vw];
        border-radius: .convert(40px) [ @vw];
        background-color: #262626;

        @media (max-width: @screen-mobile-width) {
            margin-top: .convert(30px) [ @vw-mobile];
            margin-bottom: .convert(40px) [ @vw-mobile];
            display: block;
            background-color: unset;
            padding: .convert(0px) [ @vw];
        }

        &-title {
            width: .convert(726px) [ @vw];
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            @media (max-width: @screen-mobile-width) {
                width: 100%;
            }
            &-text {
                font-family: 'HarmonyOS Sans SC';
                font-size: .convert(32px) [ @vw];
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-top: .convert(20px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(14px) [ @vw-mobile];
                }
            }
        }
        &-body {
            @media (max-width: @screen-mobile-width) {
                background-color: #262626;
                border-radius: .convert(20px) [ @vw-mobile];
                padding: .convert(35px) [ @vw-mobile] .convert(20px) [ @vw-mobile];
                margin-top: .convert(10px) [ @vw-mobile];
            }
            &-text {
                font-family: 'HarmonyOS Sans SC';
                font-size: .convert(24px) [ @vw];
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(14px) [ @vw-mobile];
                }
                &-Q {
                    margin-left: .convert(20px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        margin-left: .convert(0px) [ @vw];
                    }
                }
                &-A {
                    margin-left: .convert(20px) [ @vw];
                    margin-top: .convert(16px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        margin-top: .convert(15px) [ @vw-mobile];
                        margin-left: .convert(0px) [ @vw];
                    }
                    :deep(a) {
                        color: #37e6fe !important;
                        font-size: .convert(24px) [ @vw];
                        font-weight: 400;
                        line-height: normal;
                        text-decoration-line: underline;
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(14px) [ @vw-mobile];
                        }
                    }
                }
                &::after {
                    content: '';
                    display: block;
                    height: .convert(1px) [ @vw];
                    width: .convert(664px) [ @vw];
                    margin: .convert(40px) [ @vw] 0px; /* 分割线与元素的间距 */
                    background: rgba(102, 102, 102, 0.5);
                    @media (max-width: @screen-mobile-width) {
                        margin: .convert(20px) [ @vw-mobile] 0px; /* 分割线与元素的间距 */
                        height: .convert(1px) [ @vw-mobile];
                        width: 100%;
                    }
                }
                &:last-child::after {
                    display: none;
                }
            }
        }
    }
</style>
